const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4055_108352)">
      <path
        d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z"
        fill="#0866FF"
      />
      <path
        d="M16.6997 15.6662L17.3732 11.999H13.4535V10.702C13.4535 8.76429 14.2138 8.01885 16.1813 8.01885C16.7924 8.01885 17.2844 8.03373 17.5676 8.06349V4.73949C17.0309 4.59021 15.7191 4.44141 14.9588 4.44141C10.9489 4.44141 9.10038 6.33453 9.10038 10.4188V11.999H6.62598V15.6662H9.10038V23.6457C10.0287 23.8761 10.9997 23.999 11.9991 23.999C12.4911 23.999 12.9764 23.9688 13.453 23.9112V15.6662H16.6993H16.6997Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4055_108352">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FacebookIcon;
